const gotoUrl = (url: string, openInNewWindow = false) => {
    if (!url) {
        return;
    }

    if (!openInNewWindow) {
        window.location.href = url;
        return;
    }

    window.open(url, "_blank");
}

export default gotoUrl;
